import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { GenericLinkModule } from '@spartacus/storefront'
import { EbResponsiveMediaModule } from '../responsive-media/eb-responsive-media.module'
import { EbCmsButtonComponent } from './eb-cms-button.component'

@NgModule({
  imports: [CommonModule, EbResponsiveMediaModule, GenericLinkModule],
  providers: [
    provideConfig({
      cmsComponents: {
        ButtonComponent: {
          component: EbCmsButtonComponent
        }
      }
    } as CmsConfig)
  ],
  declarations: [EbCmsButtonComponent]
})
export class EbButtonModule {}
